import React from 'react';
import PageView from '../components/sections/PageView';

const ChefsTablePage = () => <PageView slug="chefs_table" />;

export default ChefsTablePage;
